import { render, staticRenderFns } from "./teacherDetail.vue?vue&type=template&id=632455c9&scoped=true&"
import script from "./teacherDetail.vue?vue&type=script&lang=js&"
export * from "./teacherDetail.vue?vue&type=script&lang=js&"
import style0 from "./teacherDetail.vue?vue&type=style&index=0&id=632455c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632455c9",
  null
  
)

export default component.exports